export default (sitemap: SitemapBuilder) =>
{
    sitemap.after('[[[Moduły]]]', [
        {
            name: '[[[E-learning]]]',
            short: '[[[E-learning]]]',
            icon: 'fad fa-fw fa-chalkboard-teacher',
            namespace: 'Ideo.Core.Common.Application.Permissions.Core',
            children: [
                {
                    name: '[[[Szkolenia]]]',
                    icon: 'fa-solid fa-chalkboard-user',
                    namespace: 'Ideo.Core.Elearning.Application.Permissions.Course',
                    auth: { all: ['CoursesPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Lista szkoleń]]]',
                            route: 'elearning-courses-courses',
                            icon: 'fas fa-fw fa-grip-vertical',
                            children: [
                                {
                                    name: '[[[Dodanie szkolenia]]]',
                                    route: 'elearning-courses-courses-add',
                                    auth: { all: ['CoursesPermissions@Edit'], any: [] },
                                    visible: false
                                },
                                {
                                    name: '[[[Edycja szkolenia]]]',
                                    route: 'elearning-courses-courses-edit',
                                    auth: { all: ['CoursesPermissions@Edit'], any: [] },
                                    visible: false
                                },
                                {
                                    name: '[[[Dashboard szkolenia]]]',
                                    route: 'elearning-courses-courses-dashboard',
                                    auth: { all: ['CoursesPermissions@View'], any: [] },
                                    visible: false
                                },
                                {
                                    name: '[[[Program szkolenia]]]',
                                    route: 'elearning-courses-courses-program',
                                    namespace: 'Ideo.Core.Elearning.Application.Permissions.Unit',
                                    auth: { all: ['UnitsPermissions@View'], any: [] },
                                    visible: false,
                                    children: [
                                        {
                                            name: '[[[Edycja lekcji]]]',
                                            route: 'elearning-courses-lessons-edit',
                                            auth: { all: ['UnitsPermissions@Edit'], any: [] },
                                            visible: false
                                        },
                                        {
                                            name: '[[[Dodanie lekcji]]]',
                                            route: 'elearning-courses-lessons-add',
                                            auth: { all: ['UnitsPermissions@Edit'], any: [] },
                                            visible: false
                                        },
                                        {
                                            name: '[[[Edycja testu]]]',
                                            route: 'elearning-courses-tests-edit',
                                            auth: { all: ['UnitsPermissions@Edit'], any: [] },
                                            visible: false
                                        },
                                        {
                                            name: '[[[Dodanie testu]]]',
                                            route: 'elearning-courses-tests-add',
                                            auth: { all: ['UnitsPermissions@Edit'], any: [] },
                                            visible: false
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: '[[[Kategorie szkoleń]]]',
                            route: 'elearning-courses-categories',
                            icon: 'fas fa-fw fa-grip-vertical',
                            children: [
                                {
                                    name: '[[[Dodanie kategorii]]]',
                                    route: 'elearning-courses-categories-add',
                                    auth: { all: ['CourseCategoriesPermissions@Edit'], any: [] },
                                    visible: false
                                },
                                {
                                    name: '[[[Edycja kategorii]]]',
                                    route: 'elearning-courses-categories-edit',
                                    auth: { all: ['CourseCategoriesPermissions@Edit'], any: [] },
                                    visible: false
                                }
                            ]
                        }
                    ]
                },
                {
                    name: '[[[Materiały szkoleniowe]]]',
                    icon: 'fa-solid fa-book',
                    namespace: 'Ideo.Core.Elearning.Application.Permissions.Material',
                    auth: { all: ['MaterialsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Kategorie materiałów]]]',
                            route: 'elearning-materials-categories',
                            icon: 'fas fa-fw fa-grip-vertical',
                            auth: { all: ['MaterialsPermissions@View'], any: [] },
                            children: [
                                {
                                    name: '[[[Dodanie kategorii]]]',
                                    route: 'elearning-materials-categories-add',
                                    auth: { all: ['MaterialCategoriesPermissions@Edit'], any: [] },
                                    visible: false
                                },
                                {
                                    name: '[[[Edycja kategorii]]]',
                                    route: 'elearning-materials-categories-edit',
                                    auth: { all: ['MaterialCategoriesPermissions@Edit'], any: [] },
                                    visible: false
                                }
                            ]
                        },
                        {
                            name: '[[[Slajdy]]]',
                            route: 'elearning-materials-materials-list',
                            icon: 'fas fa-fw fa-book-open',
                            children: [
                                {
                                    name: '[[[Dodanie slajdów]]]',
                                    route: 'elearning-materials-materials-add',
                                    auth: { all: ['MaterialsPermissions@Edit'], any: [] },
                                    visible: false
                                },
                                {
                                    name: '[[[Edycja slajdów]]]',
                                    route: 'elearning-materials-materials-edit',
                                    auth: { all: ['MaterialsPermissions@Edit'], any: [] },
                                    visible: false
                                },
                                {
                                    name: '[[[Import slajdów z PDF]]]',
                                    route: 'elearning-materials-materials-import',
                                    auth: { all: ['MaterialsPermissions@Edit'], any: [] },
                                    visible: false
                                }
                            ]
                        }
                    ]
                },
                {
                    name: '[[[Kreator szkoleń]]]',
                    icon: 'fa-solid fa-layer-plus',
                    route: 'elearning-courses-creator',
                    namespace: 'Ideo.Core.Elearning.Application.Permissions.Course',
                    auth: { all: ['CoursesPermissions@Edit'], any: [] },
                    visible: true
                },
                {
                    name: '[[[Paczki SCORM]]]',
                    icon: 'fa-duotone fa-film',
                    namespace: 'Ideo.Core.Elearning.Application.Permissions.Scorm',
                    auth: { all: ['ScormPackagesPermission@View'], any: [] },
                    children: [
                        {
                            name: '[[[Lista paczek SCORM]]]',
                            route: 'elearning-scorm-scormpackages',
                            icon: 'fas fa-fw fa-grip-vertical',
                            children: [
                                {
                                    name: '[[[Dodanie paczki SCORM]]]',
                                    route: 'elearning-scorm-scormpackages-add',
                                    auth: { all: ['ScormPackagesPermission@Edit'], any: [] },
                                    visible: false
                                },
                                {
                                    name: '[[[Edycja paczek SCORM]]]',
                                    route: 'elearning-scorm-scormpackages-edit',
                                    auth: { all: ['ScormPackagesPermission@Edit'], any: [] },
                                    visible: false
                                }
                            ]
                        },
                        {
                            name: '[[[Monitor aktywności]]]',
                            route: 'elearning-scorm-scormdebug',
                            namespace: 'Ideo.Core',
                            auth: { all: ['StandardPermissions@Superuser'], any: [] }
                        }
                    ]
                },
                {
                    name: '[[[Certyfikaty]]]',
                    icon: 'fa-solid fa-file-certificate',
                    namespace: 'Ideo.Core.Elearning.Application.Permissions.Certificate',
                    auth: { all: ['CertificatesPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Lista certyfikatów]]]',
                            route: 'elearning-certificates-certificates',
                            icon: 'fas fa-fw fa-grip-vertical',
                            children: [
                                {
                                    name: '[[[Dodanie certyfikatu]]]',
                                    route: 'elearning-certificates-certificates-add',
                                    auth: { all: ['CertificatesPermissions@Edit'], any: [] },
                                    visible: false
                                },
                                {
                                    name: '[[[Edycja certyfikatu]]]',
                                    route: 'elearning-certificates-certificates-edit',
                                    auth: { all: ['CertificatesPermissions@Edit'], any: [] },
                                    visible: false
                                },
                                {
                                    name: '[[[Dashboard szkolenia]]]',
                                    route: 'elearning-courses-courses-dashboard',
                                    namespace: 'Ideo.Core.Elearning.Application.Permissions.Course',
                                    auth: { all: ['CoursesPermissions@View'], any: [] },
                                    visible: false
                                }
                            ]
                        }
                    ]
                },
                {
                    name: '[[[Ścieżka szkoleniowa]]]',
                    icon: 'fa-solid fa-route',
                    namespace: 'Ideo.Core.Elearning.Application.Permissions.LearningPath',
                    auth: { all: ['LearningPathsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Lista ścieżek szkoleniowych]]]',
                            route: 'elearning-learningPath-learningPaths',
                            children: [
                                {
                                    name: '[[[Dodanie ścieżki szkoleniowej]]]',
                                    route: 'elearning-learningPath-learningPaths-add',
                                    auth: { all: ['LearningPathsPermissions@Edit'], any: [] },
                                    visible: false
                                },
                                {
                                    name: '[[[Edycja ścieżki szkoleniowej]]]',
                                    route: 'elearning-learningPath-learningPaths-edit',
                                    auth: { all: ['LearningPathsPermissions@Edit'], any: [] },
                                    visible: false
                                }
                            ]
                        }
                    ]
                },
                {
                    name: '[[[Profil koordynatora]]]',
                    icon: 'fa-solid fa-user-police-tie',
                    namespace: 'Ideo.Core.Elearning.Application.Permissions.CoordinatorProfile',
                    children: [
                        {
                            name: '[[[Lista koordynatorów]]]',
                            route: 'elearning-coordinatorProfile-coordinatorProfiles',
                            auth: { all: ['CoordinatorProfilesPermissions@View'], any: [] }
                        }
                    ]
                },
                {
                    name: '[[[Raporty]]]',
                    namespace: 'Ideo.Core.Elearning.Application.Permissions.AdminReports',
                    auth: { all: ['AdminReportsPermissions@View'], any: [] },
                    icon: 'fas fa-fw fa-chart-bar',
                    children: [
                        {
                            name: '[[[Szkoleniowe]]]',
                            route: 'elearning-reports-courses',
                            visible: true
                        },
                        {
                            name: '[[[Szczegóły szkolenia]]]',
                            route: 'elearning-reports-courses-details',
                            visible: false
                        },
                        {
                            name: '[[[Certyfikatów]]]',
                            route: 'elearning-reports-certificates',
                            visible: true
                        },
                        {
                            name: '[[[Chat z raportami szkoleń]]]',
                            route: 'aielearningreports-reports-chat',
                            visible: true
                        }
                    ]
                },
                {
                    name: '[[[Grywalizacja]]]',
                    icon: 'fa-solid fa-gamepad-modern',
                    children: [
                        {
                            name: '[[[Lista]]]',
                            route: 'elearning-gamification-list'
                        },
                        {
                            name: '[[[Przyznawanie punktów]]]',
                            route: 'elearning-gamification-points'
                        },
                        {
                            name: '[[[Odznaki]]]',
                            route: 'elearning-gamification-badges',
                            children: [
                                {
                                    name: '[[[Dodawanie odznaki]]]',
                                    route: 'elearning-gamification-badges-add',
                                    visible: false
                                },
                                {
                                    name: '[[[Edycja odznaki]]]',
                                    route: 'elearning-gamification-badges-edit',
                                    visible: false
                                }
                            ]
                        }
                    ]
                },
                {
                    name: '[[[Chat]]]',
                    route: 'chat-room-list',
                    icon: 'fas fa-fw fa-comments',
                    namespace: 'Ideo.Core.Workspace.Application.Permissions.Chat',
                    auth: { all: ['ChatPermissions@Manage'], any: [] },
                    children: [
                        {
                            name: '[[[Ustawienia]]]',
                            route: 'chat-room-settings',
                            auth: { all: ['ChatPermissions@Manage'], any: [] },
                            visible: false
                        }
                    ]
                }

            ]
        },
        {
            name: '[[[Spotkania]]]',
            short: '[[[Spotkania]]]',
            icon: 'fa-solid fa-person-chalkboard',
            children: [
                {
                    name: '[[[Spotkania]]]',
                    icon: 'fa-solid fa-person-chalkboard',
                    namespace: 'Ideo.Core.Elearning.Application.Permissions.Meeting',
                    auth: { all: ['MeetingsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Lista spotkań]]]',
                            route: 'elearning-meetings-meetings',
                            icon: 'fas fa-fw fa-grip-vertical',
                            children: [
                                {
                                    name: '[[[Dodanie spotkania]]]',
                                    route: 'elearning-meetings-meetings-add',
                                    auth: { all: ['MeetingsPermissions@Edit'], any: [] },
                                    visible: false
                                },
                                {
                                    name: '[[[Edycja spotkania]]]',
                                    route: 'elearning-meetings-meetings-edit',
                                    auth: { all: ['MeetingsPermissions@Edit'], any: [] },
                                    visible: false
                                }
                            ]
                        },
                        {
                            name: '[[[Kategorie spotkań]]]',
                            route: 'elearning-meetings-categories',
                            icon: 'fas fa-fw fa-grip-vertical',
                            children: [
                                {
                                    name: '[[[Dodanie kategorii]]]',
                                    route: 'elearning-meetings-categories-add',
                                    auth: { all: ['MeetingCategoriesPermissions@Edit'], any: [] },
                                    visible: false
                                },
                                {
                                    name: '[[[Edycja kategorii]]]',
                                    route: 'elearning-meetings-categories-edit',
                                    auth: { all: ['MeetingCategoriesPermissions@Edit'], any: [] },
                                    visible: false
                                }
                            ]
                        }
                    ]
                },
                {
                    name: '[[[Terminy]]]',
                    icon: 'fa-solid fa-screen-users',
                    namespace: 'Ideo.Core.Elearning.Application.Permissions.Meeting',
                    auth: { all: [], any: ['MeetingsPermissions@View'] },
                    children: [
                        {
                            name: '[[[Lista]]]',
                            namespace: 'Ideo.Core.Elearning.Application.Permissions.Meeting',
                            auth: { all: [], any: ['MeetingsPermissions@View'] },
                            route: 'elearning-meetings-deadlines',
                            visible: true,
                            children: [
                                {
                                    name: '[[[Dodanie terminu]]]',
                                    route: 'elearning-meetings-deadlines-add',
                                    auth: { all: [], any: ['MeetingsPermissions@Edit'] },
                                    visible: false
                                },
                                {
                                    name: '[[[Edycja terminu]]]',
                                    route: 'elearning-meetings-deadlines-edit',
                                    auth: { all: [], any: ['MeetingsPermissions@Edit'] },
                                    visible: false
                                }
                            ]
                        },
                        {
                            name: '[[[Zapisani]]]',
                            route: 'elearning-meetings-participants-deadlines',
                            auth: { all: [], any: ['MeetingsApplicationsPermissions@View'] },
                            visible: true,
                            children: [
                                {
                                    name: '[[[Terminy]]]',
                                    route: 'elearning-meetings-participants-deadlines-participants',
                                    auth: { all: [], any: ['MeetingsApplicationsPermissions@View'] },
                                    visible: false
                                }
                            ]
                        },
                        {
                            name: '[[[Postępy]]]',
                            route: 'elearning-meetings-results-deadlines',
                            auth: { all: [], any: ['MeetingsDeadlinesPermissions@Edit'] },
                            visible: true,
                            children: [
                                {
                                    name: '[[[Terminy]]]',
                                    route: 'elearning-meetings-results-deadlines-participants',
                                    auth: { all: [], any: ['MeetingsDeadlinesPermissions@Edit'] },
                                    visible: false
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]);
};
